// src/v3/navigation/collapse-menu.tsx
import SvgIcon from "@mui/material/SvgIcon";
import { jsx } from "react/jsx-runtime";
var CollapseMenuIcon = (props) => /* @__PURE__ */ jsx(SvgIcon, { "data-testid": "CollapseMenuIcon", viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.38 18.222a.79.79 0 0 1-1.58 0V5.778a.79.79 0 0 1 1.58 0v12.444Zm7.468.26-5.972-5.88v-.021a.752.752 0 0 1-.232-.57v-.042c0-.207.074-.415.232-.57l5.972-5.88a.788.788 0 0 1 .558-.229c.2 0 .4.073.559.229.305.3.305.798 0 1.099l-4.677 4.604h9.722a.79.79 0 0 1 .79.778.79.79 0 0 1-.79.778h-9.722l4.677 4.604c.305.301.305.799 0 1.1-.306.3-.811.3-1.117 0Z",
    clipRule: "evenodd"
  }
) });

export {
  CollapseMenuIcon
};
